module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-c7adcab347a95e9d11f1b86f59f3805a.png";